<template>
  <div class="ml-3">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          :allowMultipleSelection="true"
          :exportFileName="title"
        >
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  icon
                  color="blue"
                  :link="true"
                  target="_blank"
                  :to="getRoute(row.data.item)"
                >
                  <v-icon color="blue">mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("View") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="restoreItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="success">mdi-history</v-icon>
                </a>
              </template>
              <span>{{ $t("Restore") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:action-buttons>
            <v-btn
              small
              color="success"
              @click.prevent="onRestoreSelected"
              :loading="restoreLoading"
            >
              {{ $t("Restore") }}
              <v-icon>mdi-history</v-icon>
            </v-btn>
            <v-btn
              small
              color="red"
              @click.prevent="onDeleteSelected"
              :loading="deleteLoading"
            >
              {{ $t("Delete") }}
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentService from "@/services/DocumentService";
import SearchType from "@/ecm/variables/SearchType";
import Utils from "@/ecm/common/Utils";

export default {
  data() {
    return {
      deleteLoading: false,
      restoreLoading: false,
      title: this.$t("DeletedDocuments"),
      grid: {
        key: "deletedDocumentGrid",
        dataSource: DocumentService.getDeletedGrid(),
        columns: [
          {
            field: "ContentType",
            caption: this.$t("ContentType"),
            type: "string",
          },
          {
            field: "UserName",
            caption: this.$t("User"),
            type: "string",
          },
          {
            field: "DelDateFormated",
            caption: this.$t("Date"),
            type: "string",
          },
          {
            field: "VersionNumber",
            caption: this.$t("Version"),
            type: "string",
          },
          {
            field: "IpAddress",
            caption: this.$t("IP"),
            type: "string",
          },
        ],
      },
    };
  },
  computed: {
    gridInstance() {
      return this.$refs[this.grid.key];
    },
  },
  methods: {
    getRoute(dto) {
      var pattern = {
        searchPattern: dto.Id,
        searchAllVersions: true,
        allowDeleted: true,
      };
      var route = "/search/";
      route += `${SearchType.DocumentIDs}/${encodeURIComponent(
        JSON.stringify(pattern)
      )}`;
      return route;
    },
    deleteItem(dto) {
      this.$confirm(this.$t("DeleteDocumentsPermanentlyConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          DocumentService.removeDeleted([dto.Id]).then((result) => {
            this.gridInstance.refresh();
          });
        }
      });
    },
    restoreItem(dto) {
      this.$confirm(this.$t("DocumentsRestoreConfirmation"), {
        title: this.$t("Restore"),
        icon: "mdi-alert",
        color: "warning",
        buttonTrueText: this.$t("Restore"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          DocumentService.restoreDeleted([dto.Id]).then((result) => {
            this.gridInstance.refresh();
          });
        }
      });
    },
    onRestoreSelected() {
      var selectedItems = this.gridInstance.selectedRowKeys;
      if (selectedItems.length == 0) {
        Utils.toast.warning(this.$t("ItemsSelectionError"));
        return;
      }
      this.$confirm(this.$t("DocumentsRestoreConfirmation"), {
        title: this.$t("Restore"),
        icon: "mdi-alert",
        color: "warning",
        buttonTrueText: this.$t("Restore"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          this.restoreLoading = true;
          DocumentService.restoreDeleted(selectedItems)
            .then((result) => {
              this.gridInstance.refresh();
            })
            .catch((error) => {
              // error
            })
            .then(() => {
              //always
              this.restoreLoading = false;
            });
        }
      });
    },
    onDeleteSelected() {
      var selectedItems = this.gridInstance.selectedRowKeys;
      if (selectedItems.length == 0) {
        Utils.toast.warning(this.$t("ItemsSelectionError"));
        return;
      }
      this.$confirm(this.$t("DeleteDocumentsPermanentlyConfirmation"), {
        title: this.$t("Delete"),
        icon: "mdi-alert",
        color: "red",
        buttonTrueText: this.$t("Delete"),
        buttonFalseText: this.$t("Cancel"),
      }).then((res) => {
        if (res == 1) {
          this.deleteLoading = true;
          DocumentService.removeDeleted(selectedItems)
            .then((result) => {
              this.gridInstance.refresh();
            })
            .catch((error) => {
              // error
            })
            .then(() => {
              //always
              this.deleteLoading = false;
            });
        }
      });
    },
  },
};
</script>
